import { render, staticRenderFns } from "./UserRiskInfo.vue?vue&type=template&id=8be48646&scoped=true"
import script from "./UserRiskInfo.vue?vue&type=script&lang=ts"
export * from "./UserRiskInfo.vue?vue&type=script&lang=ts"
import style0 from "./UserRiskInfo.vue?vue&type=style&index=0&id=8be48646&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be48646",
  null
  
)

export default component.exports